// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2301":"79192efeab581a4d","4381":"981e8d83e5fb3c04"}[chunkId] + ".css";
};